import { useCallback, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import { useLoading } from "../../context/loadingContext";
import { isSuccessCode } from "../../helpers/apiResponse";
import * as ReportAPI from "../../api/report";
import { LoadingScreenLocal } from "../other/LoadingScreen";
import TableComponent from "../../component/form/TableComponent";
import { Column } from "../../types/TableComponent.types";
import "./ReportViewScreen.css";

type ReportFieldRow = {
    field: string;
    value: {};
};

const ReportViewScreen: React.FC = () => {
    const params = new URLSearchParams(window.location.search);
    const reportId = Number(params.get("report_id") ?? 0);

    const { association } = useAuth();
    const { loading, setLoadingStatus } = useLoading();
    const nav = useNavigate();

    const [title, setTitle] = useState("Report");
    const [rows, setRows] = useState<ReportFieldRow[]>([]);

    const associationId = String(association.id);

    const handleApiError = useCallback((requestId: string, errorCode: string) => {
        nav(`/500?process_id=${requestId}&error_code=${errorCode}`);
    }, [nav]);

    useEffect(() => {
        if (!reportId) {
            nav("/reports");
            return;
        }

        const loadReport = async () => {
            const response = await ReportAPI.detail(reportId);
            if (!isSuccessCode(response.error_code)) {
                return handleApiError(response.request_id, response.error_code);
            }

            const source = Array.isArray(response.data) ? response.data[0] : response.data;
            const data = (source ?? {}) as Record<string, unknown>;
            setTitle(String(data.name ?? data.title ?? `Report #${reportId}`));
            console.log(data);
            
            setRows(data.values as ReportFieldRow[]);
        };

        setLoadingStatus(true);
        loadReport().finally(() => setLoadingStatus(false));
    }, [associationId, handleApiError, nav, reportId, setLoadingStatus]);

    const columns: Column[] = useMemo(() => ([
        { header: "Field", accessor: "label" },
        { header: "Value", accessor: "value" },
    ]), []);

    if (loading) {
        return <LoadingScreenLocal />;
    }

    console.log(rows);
    

    return (
        <div className="report-view-screen">
            <h2>{title}</h2>
            <TableComponent data={rows} columns={columns} buttons={[]} />
        </div>
    );
};

export default ReportViewScreen;
